export default __webpack_public_path__ + "static/media/latest-postion-icon.a0529aec.svg";